/**
 * 老版本的真爱团
 * @author lianghua.fu
 * @date 2021-04-20 18:16:49
 */

import { observer } from 'mobx-react';

const TagLove = observer((props) => {
  let {
    guard = 0, //守护 类型，1，2，3
    name = '', // 真爱团名称
    level = 1, // 真爱团等级
    children,
  } = props;

  const loveName = name.toString().trim('').slice(0, 3);

  const res = loveName.match(/[\u0000-\u00ff]/gi); // 匹配单字节字符
  const byteLen = res ? res.length : 0;

  const len = Math.ceil(byteLen / 2) + loveName.length - byteLen;

  const loveType = Math.ceil(level / 10);

  return (
    <span className={`tag-love ${guard ? 'guard' + guard : 'love' + loveType}`}>
      <span
        className={`icon-love ${
          guard ? `guard${guard}` : `love${loveType}`
        }`}></span>
      <span className="tag-love-level" title={level}>
        {level}
      </span>
      <span
        className={`tag-love-name ${
          guard ? `icon-love guard${guard}-bg-${len}` : ''
        }`}
        title={loveName}>
        {loveName}
      </span>
    </span>
  );
});

export default TagLove;
